var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33322 2.25405C7.35766 1.00501 8.37782 0 9.63271 0C10.8809 0 11.8969 0.994364 11.9317 2.23417C12.6984 2.64254 13.2203 3.44991 13.2203 4.37917L6.08126 4.37917C6.08126 3.46476 6.58659 2.66838 7.33322 2.25405ZM10.6835 2.15262C10.6835 2.73184 10.2139 3.2014 9.63469 3.2014C9.05547 3.2014 8.58592 2.73184 8.58592 2.15262C8.58592 1.5734 9.05547 1.10385 9.63469 1.10385C10.2139 1.10385 10.6835 1.5734 10.6835 2.15262ZM18.9995 2.39181H17.0124V2.39183L13.847 2.39183V4.37898H17.0124V24.5817L2.25688 24.5817V4.37898L5.42139 4.37898V2.39183L0.269531 2.39183L0.269531 4.37898H0.269735V24.5817H0.269531L0.269531 26.5688H19.0002V24.5817H18.9995V2.39181Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.5fcbfe90f0ec3d34d78483317e6166b5.svg";
export { ForwardRef as ReactComponent };